import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

const { projectCode } = PROJECT_CODE;

export async function deleteUser(userId) {
	if (userId) {
		let role = '';
		await firebase
			.database()
			.ref('/users/' + userId)
			.once('value', (snapshot) => {
				let user = snapshot.val();
				if (
					user &&
					user.projectRoles &&
					user.projectRoles[projectCode]
				) {
					role = user.projectRoles[projectCode];
				}
			});

		let deleteUserAccount = firebase
			.functions()
			.httpsCallable('deleteUserAccount');
		await deleteUserAccount(userId);

		if (role === 'cobroker') {
			let coBrokerId = '';
			await firebase
				.database()
				.ref('/kavtek_coBrokers/' + projectCode)
				.once('value', (snapshot) => {
					let coBrokers = snapshot.val();
					for (let key in coBrokers) {
						if (coBrokers[key].userId === userId) {
							coBrokerId = key;
							break;
						}
					}
				});
			if (coBrokerId) {
				let coBrokerRef = firebase
					.database()
					.ref('/kavtek_coBrokers/' + projectCode + '/' + coBrokerId);
				coBrokerRef.remove();
			}
		}
	}
}
